import styled from 'styled-components';
export const $Container = styled.div `
  padding: ${({ theme }) => `${theme.spacing(1)} 0`};
`;
export const $SectionTitle = styled.h3 `
  margin: 0 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme, error }) => error && theme.colors.feedback.error};
`;
export const $SectionHeader = styled.p `
  margin: ${({ theme }) => `${theme.spacing(1)} 0`};
  padding-left: ${({ indent, theme }) => theme.spacing(indent)};
  overflow-wrap: anywhere;
  font-weight: ${({ indent }) => indent === 0 ? '700' : '600'};
  color: ${({ theme }) => theme.colors.text.title};
`;
export const $DataRow = styled.div `
  display: flex;
  align-items: baseline;
  padding-left: ${({ indent = 0, theme }) => theme.spacing(indent)};
`;
export const $DataLabel = styled.p `
  flex-shrink: 0;
  /* Cap the label so a long element name wraps instead of starving the value column */
  max-width: 60%;
  margin: ${({ theme }) => theme.spacing(1)} 0;
  overflow-wrap: anywhere;
  font-weight: ${({ group }) => group ? '800' : '500'};
  color: ${({ theme }) => theme.colors.greyScales[800]};
`;
export const $DataValue = styled.p `
  margin: ${({ theme }) => theme.spacing(1)} 0;
  margin-left: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.colors.text.title};
`;
export const $DataLink = styled.a `
  margin: ${({ theme }) => theme.spacing(1)} 0;
  margin-left: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.colors.primary.main};
  cursor: pointer;
  text-decoration: underline;
  &:hover { opacity: 0.8; }
`;
